import { Box } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ApplicationStatus,
  applyEvent,
  Prefectures,
  SexFlug,
  Status,
} from "../../assets/data/Constants";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkTable from "../../components/atoms/TkTable";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { GlobalContext } from "../../context/globalContext";
import {
  IAPI_APP016_Request,
  IAPI_STA010_Response,
  IAPI_STA013_Request,
} from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import { changeAmountFormat } from "../../utils/useTools";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_STA010, httpAPI_STA013 } from "./api/request";
import {
  funInfoBodyList,
  funStatusBodyList,
  convertMonths,
} from "./hooks/useHooks";
import {
  monthMapping,
  fakeTableList,
  headList,
  infoHeadTitleList,
  schema,
} from "./parts";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import _ from "lodash";

/**
 * SCRW070005 掛金確定後の職員情報の訂正
 * @return SCRW070005 掛金確定後の職員情報の訂正
 */

const SCRW070005 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [status, setStatus] = useState<keyof typeof ApplicationStatus>();
  const [workFlow, setWorkFlow] = useState(false);
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [responseData, setResponseData] = useState<IAPI_STA010_Response>({});
  const [selectedMonth, setSelectedMonth] = useState({});
  const location = useLocation();
  const contractorNo = location.state?.contractorNo!;
  const applyId = location.state?.applyId!;
  const [selectedYear, setSelectedYear] = useState("");
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpAPI_STA010({
        contractorNo: contractorNo,
        applyId: applyId,
      });

      let resArr = stateFakeTableList.current;

      if (res.resultCd === "I0000") {
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i);
          if (targetObj) {
            targetObj?.type === "text" &&
              (targetObj.text = res[i as keyof typeof res]);
            targetObj?.type === "date" &&
              (targetObj.setDefaultValue = res[i as keyof typeof res]);
          }
        }

        const wfFlg =
          res.latestApplyStatus !== Status["届出待ち"] &&
          res.latestApplyStatus !== Status["差戻し一時保存"];
        setWorkFlow(wfFlg);

        const apiMonthList = JSON.parse(
          JSON.stringify(res.unrecognizedMonthList)
        );
        delete apiMonthList.year;

        setResponseData(res);
        res.latestApplyStatus && setStatus(res.latestApplyStatus as Status);

        resArr.find((item) => item.keyword === "corpAddress")!.text = (
          <>
            〒{res.cozipcode}
            {TkGetCode(Prefectures, res.oprefectureCd)}
            {res.coaddressCity}
            {res.coaddressOthers}
          </>
        );

        resArr.find((item) => item.keyword === "facilityAddress")!.text =
          (TkGetCode(Prefectures, res.prefectureCd) ?? "") +
          (res.addressCity ?? "") +
          (res.addressOthers ?? "");

        resArr.find((item) => item.keyword === "facilityKind")!.text =
          res.facilityKind;

        resArr.find((item) => item.keyword === "sex")!.text = TkGetCode(
          SexFlug,
          res.sex
        );

        resArr.find((item) => item.keyword === "jobName")!.text = res.jobCd;

        let joinDate = resArr.find((item) => item.keyword === "joinDate")!;
        joinDate.disabled = wfFlg;

        resArr.find((item) => item.keyword === "facilityKbn")!.text =
          res.facilityKbn;

        resArr.find((item) => item.keyword === "salaryTableAmt")!.text =
          changeAmountFormat(res.salaryTableAmt ?? 0) + "円";

        resArr.find((item) => item.keyword === "salaryAdjustmentAmt")!.text =
          changeAmountFormat(res.salaryAdjustmentAmt ?? 0) + "円";

        resArr.find((item) => item.keyword === "sun")!.text =
          changeAmountFormat(
            (res.salaryTableAmt ?? 0) + (res.salaryAdjustmentAmt ?? 0)
          ) + "円";

        resArr.find((item) => item.keyword === "paymentAmt")!.text =
          changeAmountFormat(res.paymentAmt ?? 0) + "円";

        const unrecognizedMonthList = renderUnrecognizedMonthList(res, true);

        resArr.find((item) => item.keyword === "unrecognizedMonthList")!.node =
          unrecognizedMonthList;

        const infoBodyList = funInfoBodyList(res.childcareLeaveList);

        resArr.find((item) => item.keyword === "childcareLeaveList")!.node = (
          <Box className="node">
            <TkTable bodyList={infoBodyList} headList={infoHeadTitleList} />
          </Box>
        );

        const statusList = funStatusBodyList(res.statusList);

        let memo = resArr.find((item) => item.keyword === "memo")!;
        memo.node = (
          <Box className="node">
            <TkMemo
              bodyList={statusList}
              headList={headList}
              onChange={onChange}
            />
          </Box>
        );
        memo.showLine = wfFlg;
        setStateTableList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Object.keys(responseData).length > 0) {
      calculateNewSelectedMonth(selectedYear, responseData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, responseData, selectedMonth]);

  const calculateNewSelectedMonth = (selectedYear: any, res: any): any => {
    const listdMonth = res.unrecognizedMonthList.find(
      (item: any) => item.year === parseInt(selectedYear)
    );
    let newStateTableList = stateFakeTableList.current;
    let unrecognizedMonthList = renderUnrecognizedMonthList(
      responseData,
      false
    );
    newStateTableList.find(
      (item: any) => item.keyword === "unrecognizedMonthList"
    )!.node = unrecognizedMonthList;
    setStateTableList(newStateTableList);
    setSelectedMonth(listdMonth);
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const makeHttpObj = (num: string) => {
    let data: IAPI_APP016_Request = {
      applyId, // 申請id
      applyEvent: num, // 申請イベント
      contractorNo, // 共済契約者番号
      applyDate: "", // 契約申込日
      screenId: "SCRW070005", // 画面id
      reason: memoData, // メモ
    };
    if (memoCheck) {
      data.inquiryCode = "3"; // 照会画面への反映コード
    }

    return data;
  };

  /**
   * ならない月を作成する
   * @param res
   * @returns renderUnrecognizedMonthList
   */
  // 配列をループして各要素に対してUI要素を生成する関数
  const renderUnrecognizedMonthList = (res: any, isFromApi: boolean) => {
    const wfFlg =
      res.latestApplyStatus !== Status["届出待ち"] &&
      res.latestApplyStatus !== Status["差戻し一時保存"];
    let selectYears = [];
    for (let i = 0; i < res.unrecognizedMonthList.length; i++) {
      selectYears.push({
        value: res.unrecognizedMonthList[i].year.toString(),
        label: (res.unrecognizedMonthList[i].year.toString() ?? "") + "年",
      });
    }

    let monthArr: string[] = [];

    if (isFromApi) {
      monthArr = convertMonths(res.unrecognizedMonthList);
    } else {
      monthArr = convertMonths(selectedMonth);
    }

    const monthNode = (
      <Box>
        <Box className="part">
          <TkSelectForm
            selectPropsList={selectYears}
            disabled={wfFlg}
            wantToSetValue={res.unrecognizedMonthList[0].year}
            onChange={(e: any) => setSelectedYear(e.target.value)}
          />
        </Box>
        <Box>
          <TkCheckbox
            label="無"
            disabled={true}
            checked={monthArr.length === 0}
            value="0"
          />
          {Object.values(monthMapping).map((month: any, index: number) => {
            return (
              <TkCheckbox
                label={`${month} 月`}
                disabled={true}
                checked={monthArr.includes(month)}
                key={index}
                value={month}
              />
            );
          })}
        </Box>
      </Box>
    );

    return (
      <Box className="SCRC070004tblList">
        <TkFakeTableLine title="ならない月" type="node" node={monthNode} />
      </Box>
    );
  };

  const btnEvent = async (btnName: any) => {
    const num = applyEvent[btnName as keyof typeof applyEvent];
    if (
      num !== applyEvent["受理"] &&
      num !== applyEvent["契約者に差戻し"] &&
      num !== applyEvent["担当者に差戻し"] &&
      num !== applyEvent["課長代理確認"] &&
      num !== applyEvent["上長承認"]
    ) {
      return;
    }
    let reqData: IAPI_APP016_Request = makeHttpObj(num);

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const makeHttpObjSearch = (data: any): IAPI_STA013_Request => {
    const reqObj: IAPI_STA013_Request = {
      contractorNo: responseData.contractorNo,
      staffNo: responseData.staffNo,
      joinDate: data.joinDate,
      updateDateTime: responseData.updateDateTime,
      applyId: responseData.applyId,
      screenId: "SCRW070005",
    };

    return reqObj;
  };

  const onCheckAndSubmit = async (data: any) => {
    //掛金確定後職員情報更新
    try {
      const res = await httpAPI_STA013({
        ...makeHttpObjSearch(data),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW070005PageForTest" className="SCRW070005">
      {workFlow && (
        <TkKikoStepper
          applicationFlowType="TYPE3"
          businessType="JOB-49"
          applicationStatus={status}
        />
      )}

      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        showButton={false}
        buttonGroup={
          <Box className="btn">
            <TkBackButton />
            {workFlow && (
              <TkViewButtonJudgement
                flowType={"TYPE3"}
                Status={status as ITkViewButtonJudgementStatus}
                onClick={btnEvent}
              />
            )}
          </Box>
        }
        submitButtonGroup={[
          { submitButtonText: "更新", showButton: !workFlow },
        ]}
        onCheckAndSubmit={onCheckAndSubmit}
      />
    </Box>
  );
};

export default SCRW070005;
